<app-bread-crump [title]="'advancedSearchPage.title' | translate" [description]="'advancedSearchPage.description' | translate"
  [items]="[
    { label: 'Nav.Home' | translate, url: '/' },
    { label: 'Nav.advancedSearch' | translate }
  ]">
</app-bread-crump>

<div class="container py-4 px-4">

  <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <!-- Advanced Search Box -->
    <div class="card border border-light-subtle shadow-sm mb-4" style="border-radius: 12px; border-color: #e5e7eb !important;">
      <div class="card-body p-4 p-md-5">
        
        <!-- Top row inside card -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h5 class="m-0 fw-bold fs-5">{{ 'advancedSearchPage.searchFor' | translate }}</h5>
        </div>

        <!-- Search rows -->
        <div formArrayName="rows" class="search-rows d-flex flex-column gap-3 mb-4">
          <div *ngFor="let row of rows.controls; let i = index" [formGroupName]="i" class="d-flex align-items-center gap-3">
            
            <!-- Operator (only show for rows after the first) -->
            <div *ngIf="i > 0" style="width: 140px;">
              <select formControlName="operator" class="form-select shadow-none cursor-pointer">
                <option value="AND">{{ 'advancedSearchPage.operators.AND' | translate }}</option>
                <option value="OR">{{ 'advancedSearchPage.operators.OR' | translate }}</option>
                <option value="NOT">{{ 'advancedSearchPage.operators.NOT' | translate }}</option>
              </select>
            </div>
            
            <!-- First row padding to align with other rows -->
            <div *ngIf="i === 0" style="width: 140px;"></div>

            <!-- Term Input -->
            <div class="flex-grow-1">
              <input type="text" formControlName="term" class="form-control shadow-none" [placeholder]="'advancedSearchPage.placeholder' | translate" 
                     [ngClass]="{'is-invalid': row.get('term')?.invalid && row.get('term')?.touched}"/>
            </div>
            
            <!-- Field Dropdown -->
            <div style="width: 200px;">
              <select formControlName="field" class="form-select shadow-none cursor-pointer">
                <option *ngFor="let opt of fieldOptions" [value]="opt.value">{{ opt.label | translate }}</option>
              </select>
            </div>
            
            <!-- Delete Button (only show if more than 1 row) -->
            <button *ngIf="rows.length > 1" type="button" (click)="removeRow(i)" class="btn btn-link text-danger p-0 border-0 ms-2" aria-label="Delete row">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/>
              </svg>
            </button>
            <div *ngIf="rows.length === 1" style="width: 30px;"></div>
          </div>
        </div>
        
        <!-- Add search field button -->
        <div class="d-flex justify-content-start mt-4">
          <button type="button" (click)="addRow()" class="btn btn_black d-flex align-items-center justify-content-center gap-2 rounded-2 px-3 text-nowrap" style="height: 40px; width: fit-content !important; min-width: max-content;">
            <span>{{ 'advancedSearchPage.addSearchField' | translate }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
          </button>
        </div>
        
      </div>
    </div>

    <!-- Bottom Actions Row -->
    <div class="d-flex justify-content-between align-items-center w-100 flex-wrap gap-3">
      <!-- Right actions (بحث) -->
      <div class="d-flex gap-3 align-items-center">
        <button type="submit" class="btn btn-primary px-5 rounded-2 d-flex align-items-center justify-content-center text-nowrap" style="height: 40px; width: fit-content !important; min-width: max-content;">{{ 'advancedSearchPage.searchBtn' | translate }}</button>
      </div>

      <!-- Left actions (مسح) -->
      <div class="d-flex gap-3 align-items-center">
        <button type="button" (click)="clearForm()" class="btn d-flex align-items-center justify-content-center rounded-2 fw-medium px-5 text-nowrap" style="background-color: #f1f3f5; border: 1px solid #e5e7eb; color: #343a40; height: 40px; width: fit-content !important; min-width: max-content; box-shadow: none;">{{ 'advancedSearchPage.clearBtn' | translate }}</button>
      </div>
    </div>
  </form>
</div>

